import { subscriptionConstants } from "./constants/subscriptionConstants";

const getSubscriptionPlanRequest = (planName: string) => ({
  type: subscriptionConstants.getSubscriptionPlanRequest,
  payload: planName,
});

const createSubscriptionRequest = (data: any) => ({
  type: subscriptionConstants.createSubscriptionRequest,
  payload: data,
});

const getSubscriptionStatusRequest = (subscriptionId: string) => ({
  type: subscriptionConstants.getSubscriptionStatusRequest,
  payload: subscriptionId,
});

const getOrderStatusRequest = (orderId: string) => ({
  type: subscriptionConstants.getOrderStatusRequest,
  payload: orderId,
});

const syncPlansRequest = () => ({
  type: subscriptionConstants.syncPlansRequest,
});

const getAllPlansRequest = () => ({
  type: subscriptionConstants.getAllPlansRequest,
});

const getUserSubscriptionStatusRequest = () => ({
  type: subscriptionConstants.getUserSubscriptionStatusRequest,
});

export const subscriptionActions = {
  getSubscriptionPlanRequest,
  createSubscriptionRequest,
  getSubscriptionStatusRequest,
  getOrderStatusRequest,
  getAllPlansRequest,
  syncPlansRequest,
  getUserSubscriptionStatusRequest,
};
